// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/gauge.js';

import { paths } from '../generated/gauge';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('gauge', Original, paths);
